import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { setActivePaymentModal, setChangedDateInfo, setEditChangeDatePM } from '../../../redux/reducers/payment.reducer';
import { defaultChangedDateInfo } from '../../../types';
import { selectContractDetails } from '../../../redux/selectors/contracts.selector';
import { RootState } from '../../../redux/reducers';
import { useNavigate } from "react-router-dom";
import { contractDetails } from "../../../redux/actions/contracts.action";
// interface BackToDashboardProps {
//     // handleClose: (args: boolean) => void;
// }

export const BackToDashboard = () => {
const { selectedContractDetails } = useSelector((state: RootState) => selectContractDetails(state));

    const dispatch = useDispatch<AppDispatch>();
    
    const navigate = useNavigate();

    const handleClose = () => {
      if (selectedContractDetails?.contract_id) {
            const data = { id: selectedContractDetails?.contract_id, navigate };
            dispatch(contractDetails({ data }));
      }
        dispatch(setActivePaymentModal(null));
        dispatch(setChangedDateInfo(defaultChangedDateInfo));
        dispatch(setEditChangeDatePM(false));
    };

  return (
    <div className="d-flex flex-column align-items-center gap-3 w-100">
    {/* TODO: Below feature is pending! */}
    {/* <button className="btn border-secondary w-100 fw-600">
    Download Receipt
    </button> */}
    <button
    className="btn btn-secondary  w-100 fs-16 fw-700 black-16"
    onClick={() => {
        dispatch(setActivePaymentModal(null));
        handleClose();
    }}
    >
    Back To Dashboard
    </button>
</div>
  )
}